import { InputGroup } from "@blueprintjs/core";
import React, { useState } from "react";

import { useCreateSeriesMutation } from "../../redux/slices/series-api";
import { Button } from "../Button/button";
import { Modal } from "../modal/modal";
import styles from "./create-series-modal.module.scss";

export interface CreateSeriesModalProps {
  show: boolean;
  handleClose: () => void;
}

export const CreateSeriesModal = ({ show, handleClose }: CreateSeriesModalProps) => {
  const [seriesName, setSeriesName] = useState<string>("");
  const [createSeries] = useCreateSeriesMutation();

  const handleCreateSeries = () => {
    createSeries({ name: seriesName });
    handleClose();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleCreateSeries();
    }
  };

  return (
    <Modal
      title="CREATE SERIES"
      isOpen={show}
      onClose={handleClose}
      actions={[
        <Button intent="danger" text="Cancel" onClick={handleClose} minimal={true} key={1} />,
        <Button
          intent="primary"
          text="Create"
          onClick={handleCreateSeries}
          key={2}
          disabled={seriesName.length === 0}
        />,
      ]}
    >
      <InputGroup
        placeholder="Enter Series Name"
        leftIcon="add"
        value={seriesName}
        onChange={(e) => setSeriesName(e.target.value)}
        onKeyDown={handleKeyDown}
        className={styles.input}
      />
    </Modal>
  );
};
